import styled from 'styled-components';

const FlexContent = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;

  &:first-of-type {
    margin-top: 1.5rem;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const FieldWithLabel = styled(FlexContent)`
  > div {
    width: 80%;
  }
  > label {
    flex: 1;
  }
`;

export const PrimaryContainer = styled(FlexContent)`
  label {
    display: flex;
    align-items: center;
    margin-right: 8px;

    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
  }
`;
